export class NoIMSManifestError extends Error {
  constructor(message) {
    super(message);
    this.name = 'NoIMSManifestError';
  }
}
